<mat-sidenav-container style="height:100%;">
    <mat-sidenav #sidenav mat-component-id="sidenav" opened mode="side">
        <mat-nav-list>
            <a mat-list-item routerLink="overview" routerLinkActive="active">Overview</a>
        </mat-nav-list>
        <mat-nav-list>
            <a mat-list-item routerLink="providers" routerLinkActive="active">Providers</a>
            <a mat-list-item routerLink="applications" routerLinkActive="active">Applications</a>
        </mat-nav-list>
    </mat-sidenav>
    <router-outlet></router-outlet>
</mat-sidenav-container>
